import React, { useState, useEffect } from "react";
import Home from "../Home";
import { Tooltip } from "react-tooltip";
import { getCapitalized } from "../../utils/Helper";
import { useForm } from "react-hook-form";
import Error from "../notification/Error";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import {
  createApplication,
  getPreferencePicklist,
  getugApplicationDetail,
} from "../../redux/actions/Api";
import { HELP_TEXT, PATHS } from "../../utils";
import { NavLink, useNavigate } from "react-router-dom";
import Loader from "../Loader";
import Success from "../notification/Success";
import { resetForms, unsavedchanges } from "../../redux/actions";
import { Notes } from "../common/Notes";
import {
  AppCommon,
  ApplicationViewPage,
  PGApplicationDetails,
  UGApplicationDetails,
} from "../constantLabelFile";
import {
  programMsg,
  restrictedExternalProgram,
  restrictedmbalProgram,
  restrictedmbaProgram,
  restrictedPrograms,
restrictedMPHProgram,
} from "../../utils/DataObjects";
import { WarningModal } from "../WarningModal";
import { EMAIL_REGEX, NUM_REGEX } from "../../utils/Regex";
import {
  APU_EMAIL_DOMAIN,
  EARLIER_APU_PROGRAMMES,
  getCampusesForProgram,
  getPgPref2Campuses,
  getPgPref2Courses,
  getPreferenceCourseName,
  hasEmailDomain,
} from "../../utils/programPreference";

let DraftBtn = "";
let addedLang = ["No", "No", "No"];

const ApplicationDetailPG = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const {
    createapplicationres,
    picklistdata,
    ugappdata,
    error,
    dashboardresponse,
    preferencepicklistvalue,
  } = useSelector((state) => state.collections);

  const {
    register,
    handleSubmit,
    setValue,
    clearErrors,
    getValues,
    formState: { errors },
  } = useForm({ mode: "onTouched" });

  const [year, setYear] = useState("");
  const [lang, setLang] = useState("");
  const [loader, setLoader] = useState(true);
  const [pickListVal, setPickListVal] = useState("");
  const [nation, setNation] = useState("");
  const [programApplied, setProgramApplied] = useState("");
  const [secondprogramApplied, setSecondProgramApplied] = useState("");
  const [campusPref, setCampusPref] = useState("");
  const [campusSeco, setCampusSeco] = useState("");
  const [preTestCenter, setPreTestCenter] = useState("");
  const [preInterviewCenter, setPreInterviewCenter] = useState("");
  const [subject1, setSubject1] = useState("");
  const [subject2, setSubject2] = useState("");
  const [applicationData, setApplicationData] = useState("");
  const [campPrefe, setCampPrefe] = useState("");
  const [readOnly, setReadOnly] = useState(false);
  const [showMsg, setShowMsg] = useState("");
  const [preferencePick, setPreferencePick] = useState("");
  const [array, setArray] = useState([]);
  const [firstProgram, setFirstProgram] = useState("");
  const [secondCampPrefe, setsecondCampPrefe] = useState("");
  const [Sec, setSec] = useState("");
  const [subjectPre1, setSubjectPre1] = useState("");
  const [subjectPre2, setSubjectPre2] = useState("");
  const [consider, setConsider] = useState("");
  const [campStateone, setCampStateone] = useState();
  const [campStattwo, setCampStatetwo] = useState();
  const [isOpen, setOpen] = useState(false);
  const [allCampus, setAllCampus] = useState();
  const [studentAt, setstudentAt] = useState();

  useEffect(() => {
    if (preferencepicklistvalue?.data?.campusPreference) {
      const campusData = preferencepicklistvalue.data.campusPreference;
      let campusAll = [];
      Object.entries(campusData).forEach(([course, campuses]) => {
        campuses.forEach((campus) => {
          campusAll.push(campus.value);
        });
      });
      let campDataSame = campusAll.every((val) => val === campusAll[0]);
      setAllCampus(campDataSame);
      console.log(campDataSame, "campDataSame");
    }
  }, [preferencepicklistvalue]);

  useEffect(() => {
    if (ugappdata == undefined) {
      setLoader(true);
    } else {
      setTimeout(() => {
        setLoader(false);
      }, 1000);
    }
  }, [ugappdata]);

  useEffect(() => {
    if (error) {
      setLoader(false);
      toast.error(<Error error={error} />, {
        position: "top-center",
        autoClose: 1000,
        className: "Toastify__toast-theme--colored.Toastify__toast--warning",
      });
      setTimeout(() => {
        dispatch(resetForms());
      }, 1000);
    }
  }, [error]);

  useEffect(() => {
    if (ugappdata) {
      setApplicationData(ugappdata?.data?.records[0]);
    }
  }, [ugappdata]);

  useEffect(() => {
    let formData = {
      contactId: localStorage.getItem("contactId"),
      applicationId: localStorage.getItem("applicationId"),
    };
    if (formData) {
      dispatch(getugApplicationDetail(formData));
    }
  }, []);

  useEffect(() => {
    setPickListVal(picklistdata?.data);
    setPreferencePick(preferencepicklistvalue?.data);
  }, [picklistdata, preferencepicklistvalue]);

  useEffect(() => {
    if (dashboardresponse) {
      let formdata = {
        applicationCycleId:
          dashboardresponse?.data?.allDataOnDashboard[0]?.appCycleId,
      };
      if (formdata && dashboardresponse) {
        dispatch(getPreferencePicklist(formdata));
      }
    }
  }, [dashboardresponse]);

  useEffect(() => {
    if (year === "No") {
      setValue("yearApplied", "");
    }
  }, [year]);

  let draftMsg = {
    message: "Details Saved Successfully.",
  };

  useEffect(() => {
    if (createapplicationres?.success) {
      dispatch(unsavedchanges());
      toast.success(
        <Success response={!DraftBtn ? createapplicationres : draftMsg} />,
        {
          position: "top-center",
          autoClose: 2000,
        }
      );

      setLoader(false);
      if (!DraftBtn) {
        setTimeout(() => {
          navigate(
            PATHS.EDUCATIONDETAILPG_STR +
              dashboardresponse?.data?.allDataOnDashboard[0]?.appId
          );
        }, 500);
      } else if (DraftBtn) {
        setTimeout(() => {
          draftMsg.message = "";
        }, 500);
      }
    }
  }, [createapplicationres]);

  const [evaluationState, setEvaluationState] = useState("");

  useEffect(() => {
    setEvaluationState(
      applicationData?.hed__Applications_Applicant__r?.records[0]
        ?.Admission_Cycle__r
    );

    setValue("nationality", applicationData?.hed__Country_of_Origin__c);
    setValue("domicile", applicationData?.Domicile__c);
    setValue("gender", applicationData?.hed__Gender__c);
    setValue(
      "prevApplied",
      applicationData?.hed__Applications_Applicant__r?.records[0]
        ?.Applied_for_earlier_cycles__c
    );
    setYear(
      applicationData?.hed__Applications_Applicant__r?.records[0]
        ?.Applied_for_earlier_cycles__c
    );
    setValue(
      "yearApplied",
      applicationData?.hed__Applications_Applicant__r?.records[0]
        ?.Year_Applied_In__c
    );
    setValue(
      "haveYouStudied",
      applicationData?.Have_you_studied_at_Azim_Premji_Univ__c
    );
    setstudentAt(applicationData?.Have_you_studied_at_Azim_Premji_Univ__c);
    setValue("programName", applicationData?.Program_Name__c);
    setValue(
      "apuEmail", applicationData?.APU_email_id__c);

    setValue(
      "programApplying",
      applicationData?.hed__Applications_Applicant__r?.records[0]
        ?.First_Preference__c
    );
    setProgramApplied(
      applicationData?.hed__Applications_Applicant__r?.records[0]
        ?.First_Preference__c
    );
    setValue(
      "campus1",
      applicationData?.hed__Applications_Applicant__r?.records[0]
        ?.Campus_Preferences_1__c
    );
    setCampusPref(
      applicationData?.hed__Applications_Applicant__r?.records[0]
        ?.Campus_Preferences_1__c
    );
    setValue(
      "campus2",
      applicationData?.hed__Applications_Applicant__r?.records[0]
        ?.Campus_Preferences_2__c
    );
    setValue(
      "programPrefer",
      applicationData?.hed__Applications_Applicant__r?.records[0]
        ?.Second_Preference__c
    );
    setSecondProgramApplied(
      applicationData?.hed__Applications_Applicant__r?.records[0]
        ?.Second_Preference__c
    );
    setValue(
      "testCenter",
      applicationData?.hed__Applications_Applicant__r?.records[0]
        ?.First_Test_Center_Prefrence__c
    );
    setCampStateone(
      applicationData?.hed__Applications_Applicant__r?.records[0]
        ?.Campus_Preferences_1__c
    );
    setCampStatetwo(
      applicationData?.hed__Applications_Applicant__r?.records[0]
        ?.Campus_Preferences_2__c
    );
    setPreTestCenter(
      applicationData?.hed__Applications_Applicant__r?.records[0]
        ?.First_Test_Center_Prefrence__c
    );
    setValue(
      "subjectPreference1",
      applicationData?.hed__Applications_Applicant__r?.records[0]
        ?.Subject_Area_preference_1__c
    );
    setSubject1(
      applicationData?.hed__Applications_Applicant__r?.records[0]
        ?.Subject_Area_preference_1__c
    );
    setValue(
      "subjectPreference2",
      applicationData?.hed__Applications_Applicant__r?.records[0]
        ?.Subject_Area_preference_2__c
    );
    setSubject2(
      applicationData?.hed__Applications_Applicant__r?.records[0]
        ?.Subject_Area_preference_2__c
    );
    setValue(
      "considerAdmissionInAnyCampus",
      applicationData?.hed__Applications_Applicant__r?.records[0]
        ?.APU_consider_admission_in_any_campus__c
    );
    setConsider(
      applicationData?.hed__Applications_Applicant__r?.records[0]
        ?.APU_consider_admission_in_any_campus__c
    );
  }, [applicationData]);

  // let langMsg = {
  //   message:
  //     "Please select atleast one language proficiency as Yes on selected languages",
  // };

  const _onSubmit = (values) => {
    // if (addedLang.includes("Yes")) {
    let formData = {
      userId: localStorage.getItem("userId"),
      contactId: localStorage.getItem("contactId"),
      applicationId: localStorage.getItem("applicationId"),
      nationality: values.nationality,
      domicile: values.domicile,
      gender: values.gender,
      prevApplied: values.prevApplied,
      yearApplied: values.yearApplied,
      haveYouStudied: values.haveYouStudied,
      programName: studentAt === "Yes" ? values.programName : "",
      programYear: "",
      apuEmail: studentAt === "Yes" ? values.apuEmail : "",
      programApplying: values.programApplying,
      campus1: values.campus1,
      programPrefer: values.programPrefer,
      // campus2: campusSeco ? campusSeco : values.campus2,
      campus2: Sec === "No Second Preference" ? "" : values.campus2,
      subjectPreference1:
        firstProgram === "M.A. Education" || Sec === "M.A. Education"
          ? values.subjectPreference1
          : "",
      subjectPreference2:
        firstProgram === "M.A. Education" || Sec === "M.A. Education"
          ? values.subjectPreference2
          : "",
      testCenter: values.testCenter,
      // interviewCenter: values.interviewCenter,
      considerAdmissionInAnyCampus: values.considerAdmissionInAnyCampus,
    };

    if (formData) {
      setLoader(true);
      dispatch(createApplication(formData));
    }
    // } else {
    //   toast.error(<Error error={langMsg} />, {
    //     position: "top-center",
    //     autoClose: 1500,
    //     className: "Toastify__toast-theme--colored.Toastify__toast--warning",
    //   });
    //   setLoader(false);
    // }
  };

  useEffect(() => {
    preferencePick?.coursePreference?.map((cam) => {
      const courseName = getPreferenceCourseName(cam);
      if (
        String(cam.Id) ===
        String(
          applicationData?.hed__Applications_Applicant__r?.records[0]
            ?.First_Preference__c
        )
      ) {
        const data = getCampusesForProgram(
          preferencePick?.campusPreference,
          courseName
        );
        setCampPrefe(data);
        setFirstProgram(courseName);
      }
      if (
        String(cam.Id) ===
        String(
          applicationData?.hed__Applications_Applicant__r?.records[0]
            ?.Second_Preference__c
        )
      ) {
        const data = getCampusesForProgram(
          preferencePick?.campusPreference,
          courseName
        );
        setsecondCampPrefe(data);
        setSec(courseName);
        setSecondProgramApplied(cam?.Id);
      }
    });
  }, [applicationData, preferencepicklistvalue, preferencePick]);

  useEffect(() => {
    campPrefe &&
      campPrefe?.map((cam) => {
        if (
          cam.Id ===
            applicationData?.hed__Applications_Applicant__r?.records[0]
              ?.Campus_Preferences_1__c &&
          firstProgram === "M.A. Education"
        ) {
          const data = preferencePick?.subjectAreaPreference1[cam.value];
          setSubjectPre1(data);
          const data1 = preferencePick?.subjectAreaPreference2[cam.value];
          setSubjectPre2(data1);
        }
      });
    secondCampPrefe &&
      secondCampPrefe?.map((cam) => {
        if (
          cam?.Id ===
            applicationData?.hed__Applications_Applicant__r?.records[0]
              ?.Campus_Preferences_2__c &&
          Sec === "M.A. Education"
        ) {
          const data = preferencePick?.subjectAreaPreference1[cam.value];
          setSubjectPre1(data);
          const data1 = preferencePick?.subjectAreaPreference2[cam.value];
          setSubjectPre2(data1);
        }
      });
  }, [applicationData, preferencePick, campPrefe, secondCampPrefe]);

  useEffect(() => {
    if (Sec === "No Second Preference") {
      setValue("campus2", "");
      clearErrors("campus2");
      clearErrors("programPrefer");
      setValue("programPrefer", preferencePick?.coursePreference[0]?.Id);
      setSecondProgramApplied(preferencePick?.coursePreference[0]?.Id);
      const data = getCampusesForProgram(preferencePick?.campusPreference, Sec);
      setCampusSeco(data[0]?.Id);
      setsecondCampPrefe("");
    }
  }, [Sec, preferencePick, firstProgram]);

  // useEffect(()=>{
  //   if(preferencePick?.coursePreference?.length === 1){
  //   const program = preferencePick?.coursePreference.filter((item) =>
  //     item.value === "Master of Business Administration (Development Management)")
  //   setProgramApplied(program[0].Id)
  //   setValue("programApplying", program[0].Id)
  //   if(program){
  //   const data = preferencePick?.campusPreference[program[0].value];
  //   setCampPrefe(data)
  //   setCampusPref(data[0].Id);
  //   setValue("campus1", data[0].Id)
  //   }
  //   }
  // },[preferencePick, preferencePick?.campusPreference])

  const handleProgramApplied = (e) => {
    setFirstProgram("");
    setProgramApplied(e.target.value);
    setCampusPref("");
    setSecondProgramApplied("");
    setCampusSeco("");
    setsecondCampPrefe("");
    setSec("");
    setValue("programPrefer", "");
    setValue("campus2", "");
    clearErrors("programPrefer");
    clearErrors("campus2");

    preferencePick?.coursePreference?.map((cam) => {
      if (String(cam.Id) === String(e.target.value)) {
        const courseName = getPreferenceCourseName(cam);
        const data = getCampusesForProgram(
          preferencePick?.campusPreference,
          courseName
        );
        setCampPrefe(data);
        setFirstProgram(courseName);

       if (
          cam.value ===
          "Master of Business Administration (Development Management)"
        ) {
          setValue("programPrefer", preferencePick?.coursePreference[0]?.Id);
          const mbaCampuses = getCampusesForProgram(
            preferencePick?.campusPreference,
            "Master of Business Administration (Development Management)"
          );
          setCampPrefe(mbaCampuses);
          setCampusPref(mbaCampuses[0]?.Id);
          setValue("campus1", mbaCampuses[0]?.Id);
          setOpen(true);
        }

        if (cam.value === "M.A. Education") {
          setValue("subjectPreference1", "");
          setValue("subjectPreference2", "");
          setSubject1("");
          setSubject2("");
        }
      }
    });

    dispatch(unsavedchanges(e.target.value));
    clearErrors("programApplying");
  };

  const handleSecondProgramApplied = (e) => {
    setCampusSeco("");
    setsecondCampPrefe("");
    setSecondProgramApplied(e.target.value);
    setValue("campus2", "");
    clearErrors("campus2");

    preferencePick?.coursePreference?.map((cam) => {
      if (String(cam.Id) === String(e.target.value)) {
        const courseName = getPreferenceCourseName(cam);
        const data = getCampusesForProgram(
          preferencePick?.campusPreference,
          courseName
        );
        const filteredCampuses = getPgPref2Campuses({
          campuses: data,
          firstProgramName: firstProgram,
          secondProgramName: courseName,
        });
        setSec(courseName);
        setsecondCampPrefe(filteredCampuses);
        if (filteredCampuses.length === 1) {
          setCampusSeco(filteredCampuses[0]?.Id);
          setValue("campus2", filteredCampuses[0]?.Id);
        }
        if (courseName === "No Second Preference") {
          setCampusSeco(data[0]?.Id);
          setValue("campus2", "");
          clearErrors("campus2");
          setsecondCampPrefe("");
        }

        if (cam.value === "M.A. Education") {
          setValue("subjectPreference1", "");
          setValue("subjectPreference2", "");
          setSubject1("");
          setSubject2("");
        }
      }
    });
    dispatch(unsavedchanges(e.target.value));
    clearErrors("programPrefer");
  };

  const handleCampus = (e, camp) => {
    if (camp === "camp1") {
      setCampusPref(e.target.value);
      setSecondProgramApplied("");
      setCampusSeco("");
      setsecondCampPrefe("");
      setSec("");
      setValue("programPrefer", "");
      setValue("campus2", "");
      clearErrors("programPrefer");
      clearErrors("campus2");
      campPrefe?.map((cam) => {
        if (cam.Id === e.target.value) {
          setCampStateone(e.target.value);
        }
        if (cam.Id === e.target.value && firstProgram === "M.A. Education") {
          setCampStateone(e.target.value);
          const data = preferencePick?.subjectAreaPreference1[cam.value];
          setSubjectPre1(data);
          const data1 = preferencePick?.subjectAreaPreference2[cam.value];
          setSubjectPre2(data1);
        }
      });
      dispatch(unsavedchanges(e.target.value));
      clearErrors("campus1");
    } else if (camp === "camp2") {
      setCampusSeco(e.target.value);
      secondCampPrefe?.map((cam) => {
        if (cam.Id === e.target.value) {
          setCampStatetwo(e.target.value);
        }
        if (cam?.Id === e.target.value && Sec === "M.A. Education") {
          setCampStatetwo(e.target.value);
          const data = preferencePick?.subjectAreaPreference1[cam.value];
          setSubjectPre1(data);
          const data1 = preferencePick?.subjectAreaPreference2[cam.value];
          setSubjectPre2(data1);
        }
      });
      dispatch(unsavedchanges(e.target.value));
      clearErrors("campus2");
    }
  };

  const currentDate = new Date();
  const year1 = currentDate.getFullYear();
  const month = String(currentDate.getMonth() + 1).padStart(2, "0");
  const day = String(currentDate.getDate()).padStart(2, "0");
  const formattedDate = `${year1}-${month}-${day}`;

  useEffect(() => {
    if (
      applicationData?.hed__Applications_Applicant__r?.records[0]
        ?.hed__Application_Status__c === "Started" ||
      applicationData?.hed__Applications_Applicant__r?.records[0]
        ?.hed__Application_Status__c === "Draft" ||
      applicationData?.hed__Applications_Applicant__r?.records[0]
        ?.hed__Application_Status__c === "Payment Failed" ||
      applicationData?.hed__Applications_Applicant__r?.records[0]
        ?.hed__Application_Status__c === "Payment Pending" ||
      applicationData?.hed__Applications_Applicant__r?.records[0]
        ?.hed__Application_Status__c === "Payment Submitted"
    ) {
      if (
        formattedDate >
        applicationData?.hed__Applications_Applicant__r?.records[0]
          ?.Admission_Cycle__r?.Application_Submission_Date__c
      ) {
        setReadOnly(true);
        setShowMsg(<Notes name="ADM_Cycle_Validation_App" />);
      } else {
        setReadOnly(false);
        setShowMsg("");
      }
    } else {
      if (
        formattedDate <
        applicationData?.hed__Applications_Applicant__r?.records[0]
          ?.Admission_Cycle__r?.Application_Submission_Date__c
      ) {
        setReadOnly(true);
        setShowMsg("");
      } else {
        setReadOnly(true);
        setShowMsg(<Notes name="ADM_Cycle_Validation_App" />);
      }
    }
  }, [applicationData]);

  useEffect(() => {
    if (
      applicationData?.hed__Applications_Applicant__r?.records[0]
        ?.Not_Eligible__c
    ) {
      setReadOnly(true);
      setShowMsg("");
    }
  }, [applicationData]);

  useEffect(() => {
    let filteredArray = pickListVal?.subjectAreaPreference2?.filter(
      (val) => val.value !== "No Second Preference"
    );

    let noSecondPreference = pickListVal?.subjectAreaPreference2?.find(
      (val) => val.value === "No Second Preference"
    );

    if (noSecondPreference) {
      filteredArray.unshift(noSecondPreference);
    }

    setArray(filteredArray);
  }, [pickListVal]);

  // const handlePopup = () => {
  //     if(restrictedPrograms?.includes(programfirst))
  //       {
  //         setProgramSecond("")
  //         setOpen(true)
  //       }
  //       else if(restrictedPrograms?.includes(programSecond)){
  //       setProgramFirst("")
  //       setOpen(true)
  //     }
  //   }

  //   useEffect(()=>{
  //     handlePopup()
  //   },[programfirst, programSecond])

  const handleOpenModal = () => {
 if(firstProgram === "Master of Public Health"){
      return (
        <WarningModal
          isOpen={isOpen}
          message={restrictedMPHProgram[firstProgram]}
          onHide={() => {
            setOpen(false);
          }}
        />
      );
    }  
  if (evaluationState?.APU_Evaluation_Mode_1__c === "External exam") {
      return (
        <WarningModal
          isOpen={isOpen}
          message={restrictedExternalProgram[firstProgram]}
          onHide={() => {
            setOpen(false);
          }}
        />
      );
    } else
      return (
        <WarningModal
          isOpen={isOpen}
          message={restrictedmbaProgram[firstProgram]}
          onHide={() => {
            setOpen(false);
          }}
        />
      );
  };

  const selectedPref1Course = Array.isArray(preferencePick?.coursePreference)
    ? preferencePick.coursePreference.find(
        (course) => String(course.Id) === String(programApplied)
      )
    : null;
  const pref1ProgramName =
    firstProgram || getPreferenceCourseName(selectedPref1Course);
  const pgPref2Courses = getPgPref2Courses({
    coursePreference: preferencePick?.coursePreference,
    firstProgramName: pref1ProgramName,
  });
  const pgPref2Campuses = getPgPref2Campuses({
    campuses: secondCampPrefe,
    firstProgramName: pref1ProgramName,
    secondProgramName: Sec,
  });

  return (
    <Home>
      <div class="right_panel">
        {firstProgram ===
          "Master of Business Administration (Development Management)" || firstProgram === "Master of Public Health" &&
          handleOpenModal()}
        {/* {
              evaluationState?.APU_Evaluation_Mode_1__c === "External exam" && 
              <WarningModal isOpen={isOpen} 
              message={programMsg[programfirst] || programMsg[programSecond]}
              onHide={()=>{setOpen(false); setProgramFirst(""); setProgramSecond("")}} />} */}
        <div class="w100">
          <p className="top_head_styl">{showMsg}</p>
          <h4 className="top_head">
            {getCapitalized(PGApplicationDetails.Postgraduate_Programme)}
          </h4>
          <span className="help_link">
            <p>
              <NavLink to={PATHS.RAISEQUERY}>{HELP_TEXT}</NavLink>{" "}
              <Tooltip id="helpTooltip">
                <p>{ApplicationViewPage.Help_Tooltip_Text}</p>
              </Tooltip>
              <i
                data-tooltip-id="helpTooltip"
                class="fa-solid fa-circle-info"
              ></i>
            </p>
          </span>
        </div>
        <Loader show={loader} />
        <form onSubmit={handleSubmit(_onSubmit)} disabled={readOnly}>
          <div className="w100 scroll_styl">
            <div class="heading_styl head_font">
              <h4>
                {getCapitalized(PGApplicationDetails.Application_Details)}
              </h4>
            </div>
            <div class="form_sec form_part">
              <div class="form_styl">
                <div class="w100">
                  <a
                    // href="https://azimpremjiuniversity.edu.in/postgraduate/application-process-and-timeline"
                    href=" https://azimpremjiuniversity.edu.in/postgraduate/eligibility-and-diversity"
                    className="linkcheckegi"
                    target="_blank"
                  >
                    {PGApplicationDetails.Eligibility_Criteria_Message}
                  </a>{" "}
                </div>
              </div>

              <div class="heading_styl">
                <h4>{PGApplicationDetails.Background_Details}</h4>
              </div>

              <div class="form_styl">
                <div class="inner_part">
                  <label>
                    {PGApplicationDetails.Nationality}{" "}
                    <span class="redstyl">* </span>
                  </label>
                  <select
                    {...register("nationality", {
                      required: {
                        value: true,
                        message: "Please select value",
                      },
                    })}
                    disabled={readOnly}
                    className={`${errors.nationality ? "error_msg" : ""}`}
                    onChange={(e) => {
                      setNation(e.target.value);
                      dispatch(unsavedchanges(e.target.value));
                      clearErrors("nationality");
                    }}
                  >
                    <option value="" disabled selected>
                      {AppCommon.Dropdown_Default_Option}
                    </option>
                    {pickListVal &&
                      pickListVal?.nationality.map((opt, ind) => (
                        <option key={ind} value={opt.value}>
                          {opt.value}
                        </option>
                      ))}
                  </select>
                  {errors.nationality && (
                    <div className="error_shown">
                      {errors.nationality?.message}
                    </div>
                  )}
                </div>
                <div class="inner_part">
                  <label>
                    {PGApplicationDetails.Gender}{" "}
                    <span class="redstyl">* </span>
                  </label>
                  <select
                    {...register("gender", {
                      required: {
                        value: true,
                        message: "Please select value",
                      },
                    })}
                    onChange={(e) => {
                      dispatch(unsavedchanges(e.target.value));
                      clearErrors("gender");
                    }}
                    disabled={readOnly}
                    className={`${errors.gender ? "error_msg" : ""}`}
                  >
                    <option value="" disabled selected>
                      {AppCommon.Dropdown_Default_Option}
                    </option>
                    {pickListVal &&
                      pickListVal?.gender?.map((opt, ind) => (
                        <option key={ind} value={opt.value}>
                          {opt.value}
                        </option>
                      ))}
                  </select>
                  {errors.gender && (
                    <div className="error_shown">{errors.gender?.message}</div>
                  )}
                </div>
              </div>
              <div class="form_styl">
                <div class="inner_part">
                  <label>
                    {PGApplicationDetails.Applied_Before}{" "}
                    <span class="redstyl">* </span>
                  </label>
                  <select
                    {...register("prevApplied", {
                      required: {
                        value: true,
                        message: "Please select value",
                      },
                    })}
                    disabled={readOnly}
                    className={`${errors.prevApplied ? "error_msg" : ""}`}
                    onChange={(e) => {
                      setYear(e.target.value);
                      dispatch(unsavedchanges(e.target.value));
                      clearErrors("prevApplied");
                    }}
                  >
                    <option value="" disabled selected>
                      {AppCommon.Dropdown_Default_Option}
                    </option>
                    {pickListVal &&
                      pickListVal?.appliedEarlier.map((app, ind) => (
                        <option value={app.value}>{app.value}</option>
                      ))}
                  </select>
                  {errors.prevApplied && (
                    <div className="error_shown">
                      {errors.prevApplied.message}
                    </div>
                  )}
                </div>
                {year === "Yes" && (
                  <div class="inner_part">
                    <label>
                      {PGApplicationDetails.Applied_Year}{" "}
                      <span class="redstyl">* </span>
                    </label>
                    <input
                      {...register("yearApplied", {
                        required: {
                          value: true,
                          message: "Please enter value",
                        },
                        pattern: {
                          value: NUM_REGEX,
                          message:
                            "Your entry does not match the allowed pattern.",
                        },
                        maxLength: {
                          value: 4,
                          message: "Please enter valid year",
                        },
                        minLength: {
                          value: 4,
                          message: "Please enter valid year",
                        },
                      })}
                      autoComplete="off"
                      className={`${errors.yearApplied ? "error_msg" : ""}`}
                      maxLength="4"
                      onChange={(e) => {
                        dispatch(unsavedchanges(e.target.value));
                        clearErrors("yearApplied");
                      }}
                      disabled={readOnly}
                      type="text"
                    />
                    {errors.yearApplied && (
                      <div className="error_shown">
                        {errors.yearApplied?.message}
                      </div>
                    )}
                  </div>
                )}
              </div>
             
                <div class="form_styl">
                  <div class="inner_part">
                    <label>
                      {/* {UGApplicationDetails.Applied_Year}{" "}                     */}
                      Are you currently or have ever been a student at Azim
                      Premji University?
                      <span class="redstyl">* </span>
                    </label>
                    <select
                      {...register("haveYouStudied", {
                        required: {
                          value: true,
                          message: "Please enter value",
                        },
                      })}
                      autoComplete="off"
                      className={`${errors.haveYouStudied ? "error_msg" : ""}`}
                      maxLength="255"
                      onChange={(e) => {
                        setstudentAt(e.target.value);
                        if (e.target.value !== "Yes") {
                          setValue("programName", "");
                          setValue("apuEmail", "");
                          clearErrors("programName");
                          clearErrors("apuEmail");
                        }
                        dispatch(unsavedchanges(e.target.value));
                        clearErrors("haveYouStudied");
                      }}
                      disabled={readOnly}
                    >
                      <option value="" disabled selected>
                        {AppCommon.Dropdown_Default_Option}
                      </option>
                      {pickListVal &&
                        pickListVal?.haveYouStudiedAtAzimPremji.map(
                          (app, ind) => (
                            <option value={app.value}>{app.value}</option>
                          )
                        )}
                    </select>
                    {errors.haveYouStudied && (
                      <div className="error_shown">
                        {errors.haveYouStudied?.message}
                      </div>
                    )}
                  </div>
                </div>
             

              { studentAt === "Yes" && (
                <div class="form_styl">
                  <div class="inner_part">
                    <label>
                      Programme Name
                      <span class="redstyl">*</span>
                    </label>
                    <select
                      {...register("programName", {
                        required: {
                          value: true,
                          message: "Please select value",
                        },
                      })}
                      disabled={readOnly}
                      // value={year}
                      className={`${errors.programName ? "error_msg" : ""}`}
                      onChange={(e) => {
                        // setYear(e.target.value);
                        dispatch(unsavedchanges(e.target.value));
                        clearErrors("programName");
                      }}
                    >
                      <option value="" disabled selected>
                        {AppCommon.Dropdown_Default_Option}
                      </option>
                      {EARLIER_APU_PROGRAMMES.map((app) => (
                        <option key={app} value={app}>
                          {app}
                        </option>
                      ))}
                    </select>
                    {errors.programName && (
                      <div className="error_shown">
                        {errors.programName?.message}
                      </div>
                    )}
                  </div>
                  <div class="inner_part">
                    <label>
                      {PGApplicationDetails.Your_APU_Email}{" "}
                      <span class="redstyl">* </span>
                    </label>
                    <input
                      type="text"
                      autoComplete="off"
                      disabled={readOnly}
                      className={`${errors.apuEmail ? "error_msg" : ""}`}
                      {...register("apuEmail", {
                        required: {
                          value: true,
                          message: "Please enter value",
                        },
                        pattern: {
                          value: EMAIL_REGEX,
                          message: "Please enter valid email",
                        },
                        validate: (val) =>
                          hasEmailDomain(val, APU_EMAIL_DOMAIN) ||
                          AppCommon.Invalid_Email_Domain,
                        onChange: (e) => {
                          dispatch(unsavedchanges(e.target.value));
                        },
                      })}
                    />
                    {errors.apuEmail && (
                      <div className="error_shown">
                        {errors.apuEmail?.message}
                      </div>
                    )}
                  </div>
                </div>
              )}

              <div class="form_styl">
                <div class="inner_part">
                  <label>
                    {PGApplicationDetails.Domicile}{" "}
                    <span class="redstyl">* </span>
                  </label>
                  <select
                    {...register("domicile", {
                      required: {
                        value: true,
                        message: "Please select value",
                      },
                    })}
                    onChange={(e) => {
                      dispatch(unsavedchanges(e.target.value));
                      clearErrors("domicile");
                    }}
                    disabled={readOnly}
                    className={`${errors.domicile ? "error_msg" : ""}`}
                  >
                    <option value="" disabled selected>
                      {AppCommon.Dropdown_Default_Option}
                    </option>
                    {pickListVal &&
                      pickListVal?.domicile?.map((opt, ind) => (
                        <option key={opt.ind} value={opt.value}>
                          {opt.value}
                        </option>
                      ))}
                  </select>
                  {errors.domicile && (
                    <div className="error_shown">{errors.domicile.message}</div>
                  )}
                </div>
              </div>

              <div class="heading_styl">
                <h4>{PGApplicationDetails.Programme_Applying}</h4>
              </div>
              <div class="form_styl">
                <div class="inner_part">
                  <label>
                    {UGApplicationDetails.Programme_Preference_1}{" "}
                    <span class="redstyl">* </span>
                  </label>
                  <select
                    {...register("programApplying", {
                      required: {
                        value: true,
                        message: "Please select value",
                      },
                    })}
                    className={`${errors.programApplying ? "error_msg" : ""}`}
                    value={programApplied}
                    onChange={handleProgramApplied}
                    disabled={
                      applicationData?.hed__Applications_Applicant__r
                        ?.records[0]?.Not_Eligible__c || readOnly
                      // &&
                      // formattedDate >
                      //   applicationData?.hed__Applications_Applicant__r
                      //     ?.records[0]?.Admission_Cycle__r
                      //     ?.Preference_End_Date__c
                    }
                  >
                    <option value="" disabled selected>
                      {AppCommon.Dropdown_Default_Option}
                    </option>
                    {preferencePick &&
                      preferencePick?.coursePreference
                        ?.filter((val) => {
                          return !(val.value === "No Second Preference");
                        })
                        ?.map((opt, ind) => (
                          <option
                            key={ind}
                            value={opt.Id}
                            disabled={opt.value === Sec}
                          >
                            {opt.value}
                          </option>
                        ))}
                    {/* {preferencePick &&
                      preferencePick?.coursePreference?.map((opt, ind) => (
                        <option key={ind} value={opt.Id} disabled={ opt.value === "No Second Preference" || opt.value === Sec}>
                          {opt.value}
                        </option>
                      ))} */}
                  </select>
                  {errors.programApplying && (
                    <div className="error_shown">
                      {errors.programApplying?.message}
                    </div>
                  )}
                </div>

                <div class="inner_part">
                  <label>
                    {PGApplicationDetails.Campus}{" "}
                    <span class="redstyl">* </span>
                  </label>
                  <select
                    {...register("campus1", {
                      required: {
                        value: true,
                        message: "Please select value",
                      },
                    })}
                    className={`${errors.campus1 ? "error_msg" : ""}`}
                    value={campusPref}
                    onChange={(e) => {
                      handleCampus(e, "camp1");
                    }}
                    disabled={
                      !programApplied ||
                      applicationData?.hed__Applications_Applicant__r
                        ?.records[0]?.Not_Eligible__c ||
                      readOnly
                      // (formattedDate >
                      //   applicationData?.hed__Applications_Applicant__r
                      //     ?.records[0]?.Admission_Cycle__r
                      //     ?.Preference_End_Date__c &&
                      //   readOnly)
                    }
                  >
                    <option value="" disabled selected>
                      {AppCommon.Dropdown_Default_Option}
                    </option>
                    {campPrefe &&
                      campPrefe?.map((opt, ind) => (
                        <option key={ind} value={opt.Id}>
                          {opt.value}
                        </option>
                      ))}
                  </select>
                  {errors.campus1 && (
                    <div className="error_shown">{errors.campus1?.message}</div>
                  )}
                </div>
              </div>

              {firstProgram === "M.A. Education" && (
                <>
                  <div class="form_styl">
                    <div class="inner_part">
                      <label>
                        {PGApplicationDetails.Subject_Area_Preference_1}{" "}
                        <span class="redstyl">* </span>
                      </label>
                      <select
                        {...register("subjectPreference1", {
                          required: {
                            value: true,
                            message: "Please select value",
                          },
                        })}
                        className={`${
                          errors.subjectPreference1 ? "error_msg" : ""
                        }`}
                        value={subject1}
                        disabled={
                          readOnly
                          // &&
                          // formattedDate >
                          //   applicationData?.hed__Applications_Applicant__r
                          //     ?.records[0]?.Admission_Cycle__r
                          //     ?.Preference_End_Date__c
                        }
                        onChange={(e) => {
                          setSubject1(e.target.value);
                          dispatch(unsavedchanges(e.target.value));
                          clearErrors("subjectPreference1");
                        }}
                      >
                        <option value="" selected>
                          {AppCommon.Dropdown_Default_Option}
                        </option>
                        {subjectPre1 &&
                          subjectPre1?.map((opt, ind) => (
                            <option
                              key={ind}
                              value={opt.value}
                              disabled={
                                opt.value === "No Second Preference" ||
                                opt.value == subject2
                              }
                            >
                              {opt.value}
                            </option>
                          ))}
                      </select>
                      {errors.subjectPreference1 && (
                        <div className="error_shown">
                          {errors.subjectPreference1.message}
                        </div>
                      )}
                    </div>
                  </div>
                  <div class="form_styl">
                    <div class="inner_part">
                      <label>
                        {PGApplicationDetails.Subject_Area_Preference_2}{" "}
                        <span class="redstyl">* </span>
                      </label>
                      <select
                        {...register("subjectPreference2", {
                          required: {
                            value: true,
                            message: "Please select value",
                          },
                        })}
                        className={`${
                          errors.subjectPreference2 ? "error_msg" : ""
                        }`}
                        value={subject2}
                        disabled={
                          readOnly
                          // &&
                          // formattedDate >
                          //   applicationData?.hed__Applications_Applicant__r
                          //     ?.records[0]?.Admission_Cycle__r
                          //     ?.Preference_End_Date__c
                        }
                        onChange={(e) => {
                          setSubject2(e.target.value);
                          dispatch(unsavedchanges(e.target.value));
                          clearErrors("subjectPreference2");
                        }}
                      >
                        <option value="" selected>
                          {AppCommon.Dropdown_Default_Option}
                        </option>
                        {/* {array &&
                          array?.map((opt, ind) => (
                            <option
                              key={ind}
                              value={opt.value}
                              disabled={opt.value == subject1}
                            >
                              {opt.value}
                            </option>
                          ))} */}
                        {subjectPre2 &&
                          subjectPre2.map((opt, ind) => (
                            <option
                              key={ind}
                              value={opt.value}
                              disabled={opt.value == subject1}
                            >
                              {opt.value}
                            </option>
                          ))}
                      </select>
                      {errors.subjectPreference2 && (
                        <div>{errors.subjectPreference2.message}</div>
                      )}
                    </div>
                  </div>

                  <div class="form_styl">
                    <div class="inner_part">
                      <Notes name="Subject_Area_Note" />
                    </div>
                  </div>
                </>
              )}
              {!dashboardresponse?.data?.allDataOnDashboard[0]?.appCycleName?.includes(
                "MBA"
              ) && (
                <div class="form_styl">
                  <div class="inner_part">
                    <label>
                      {UGApplicationDetails.Programme_Preference_2}{" "}
                      <span class="redstyl">* </span>
                      <Tooltip id="progPreference">
                        <p>
                          {
                            PGApplicationDetails.Programme_Preference_2_Tooltip_Message
                          }{" "}
                        </p>
                      </Tooltip>
                      <i
                        data-tooltip-id="progPreference"
                        class="fa-solid fa-circle-info"
                      ></i>
                    </label>

                    <select
                      {...register("programPrefer", {
                        required: {
                          value: true,
                          message: "Please select value",
                        },
                      })}
                      className={`${errors.programPrefer ? "error_msg" : ""}`}
                      value={secondprogramApplied}
                      onChange={handleSecondProgramApplied}
                      disabled={
                        !firstProgram ||
                        !campusPref ||
                        readOnly
                      }
                    >
                      <option value="" selected>
                        {AppCommon.Dropdown_Default_Option}
                      </option>
                      {/* {preferencePick &&
                      preferencePick?.coursePreference?.map((opt, ind) => (
                        <option
                          key={ind}
                          disabled={opt.Id == programApplied}
                          value={opt.Id}
                        >
                          {opt.value}
                        </option>
                      ))} */}

                      {pgPref2Courses?.map((opt, ind) => (
                            <option
                              key={ind}
                              value={opt.Id}
                            >
                              {opt.value}
                            </option>
                          ))}
                    </select>
                    {errors.programPrefer && (
                      <div className="error_shown">
                        {errors.programPrefer?.message}
                      </div>
                    )}
                  </div>
                  <div class="inner_part">
                    <label>
                      {UGApplicationDetails.Campus}{" "}
                      <span class="redstyl">* </span>
                    </label>
                    <select
                      {...register("campus2", {
                        required: {
                          value: !campusSeco ? true : false,
                          message: "Please select value",
                        },
                      })}
                      className={`${
                        !campusSeco && errors.campus2 ? "error_msg" : ""
                      }`}
                      // value={campusSeco}
                      onChange={(e) => {
                        handleCampus(e, "camp2");
                      }}
                      disabled={
                        !firstProgram ||
                        !secondprogramApplied ||
                        secondprogramApplied === "0019D00000M5lAHQAZ" ||
                        readOnly
                      }
                    >
                      <option value="" disabled selected>
                        {AppCommon.Dropdown_Default_Option}
                      </option>
                      {pgPref2Campuses &&
                        pgPref2Campuses?.map((opt, ind) => (
                          <option key={ind} value={opt.Id}>
                            {opt.value}
                          </option>
                        ))}
                    </select>

                    {!campusSeco && errors.campus2 && (
                      <div className="error_shown">
                        {errors.campus2?.message}
                      </div>
                    )}
                  </div>
                </div>
              )}
              {Sec === "M.A. Education" && (
                <>
                  <div class="form_styl">
                    <div class="inner_part">
                      <label>
                        {PGApplicationDetails.Subject_Area_Preference_1}{" "}
                        <span class="redstyl">* </span>
                      </label>
                      <select
                        {...register("subjectPreference1", {
                          required: {
                            value: true,
                            message: "Please select value",
                          },
                        })}
                        className={`${
                          errors.subjectPreference1 ? "error_msg" : ""
                        }`}
                        value={subject1}
                        disabled={
                          readOnly
                          // &&
                          // formattedDate >
                          //   applicationData?.hed__Applications_Applicant__r
                          //     ?.records[0]?.Admission_Cycle__r
                          //     ?.Preference_End_Date__c
                        }
                        onChange={(e) => {
                          setSubject1(e.target.value);
                          dispatch(unsavedchanges(e.target.value));
                          clearErrors("subjectPreference1");
                        }}
                      >
                        <option value="" selected>
                          {AppCommon.Dropdown_Default_Option}
                        </option>
                        {subjectPre1 &&
                          subjectPre1?.map((opt, ind) => (
                            <option
                              key={ind}
                              value={opt.value}
                              disabled={
                                opt.value === "No Second Preference" ||
                                opt.value == subject2
                              }
                            >
                              {opt.value}
                            </option>
                          ))}
                      </select>
                      {errors.subjectPreference1 && (
                        <div className="error_shown">
                          {errors.subjectPreference1.message}
                        </div>
                      )}
                    </div>
                  </div>
                  <div class="form_styl">
                    <div class="inner_part">
                      <label>
                        {PGApplicationDetails.Subject_Area_Preference_2}{" "}
                        <span class="redstyl">* </span>
                      </label>
                      <select
                        {...register("subjectPreference2", {
                          required: {
                            value: true,
                            message: "Please select value",
                          },
                        })}
                        className={`${
                          errors.subjectPreference2 ? "error_msg" : ""
                        }`}
                        value={subject2}
                        disabled={
                          readOnly
                          // &&
                          // formattedDate >
                          //   applicationData?.hed__Applications_Applicant__r
                          //     ?.records[0]?.Admission_Cycle__r
                          //     ?.Preference_End_Date__c
                        }
                        onChange={(e) => {
                          setSubject2(e.target.value);
                          dispatch(unsavedchanges(e.target.value));
                          clearErrors("subjectPreference2");
                        }}
                      >
                        <option value="" selected>
                          {AppCommon.Dropdown_Default_Option}
                        </option>
                        {/* {array &&
                          array?.map((opt, ind) => (
                            <option
                              key={ind}
                              value={opt.value}
                              disabled={opt.value == subject1}
                            >
                              {opt.value}
                            </option>
                          ))} */}
                        {subjectPre2 &&
                          subjectPre2.map((opt, ind) => (
                            <option
                              key={ind}
                              value={opt.value}
                              disabled={opt.value == subject1}
                            >
                              {opt.value}
                            </option>
                          ))}
                      </select>
                      {errors.subjectPreference2 && (
                        <div>{errors.subjectPreference2.message}</div>
                      )}
                    </div>
                  </div>

                  <div class="form_styl">
                    <div class="inner_part">
                      <Notes name="Subject_Area_Note" />
                    </div>
                  </div>
                </>
              )}

              {!allCampus && (
                <>
                  <div class="form_styl">
                    <div class="inner_part">
                      <label>
                        {PGApplicationDetails.Preference_Question}{" "}
                        <span class="redstyl">* </span>
                      </label>
                      <select
                        {...register("considerAdmissionInAnyCampus", {
                          required: {
                            value: true,
                            message: "Please select value",
                          },
                        })}
                        className={`${
                          errors.considerAdmissionInAnyCampus ? "error_msg" : ""
                        }`}
                        value={consider}
                        disabled={
                          readOnly
                          // &&
                          // formattedDate >
                          //   applicationData?.hed__Applications_Applicant__r
                          //     ?.records[0]?.Admission_Cycle__r
                          //     ?.Preference_End_Date__c
                        }
                        onChange={(e) => {
                          setConsider(e.target.value);
                          dispatch(unsavedchanges(e.target.value));
                          clearErrors("considerAdmissionInAnyCampus");
                        }}
                      >
                        <option value="" selected>
                          {AppCommon.Dropdown_Default_Option}
                        </option>
                        {pickListVal &&
                          pickListVal?.considerAdmissionInAnyCampus?.map(
                            (opt, ind) => (
                              <option key={ind} value={opt.value}>
                                {opt.value}
                              </option>
                            )
                          )}
                      </select>
                      {errors.considerAdmissionInAnyCampus && (
                        <div>{errors.considerAdmissionInAnyCampus.message}</div>
                      )}
                    </div>
                  </div>
                  <div class="form_styl">
                    <div class="inner_part w100">
                      <Notes name="Consider_any_campus" />
                    </div>
                  </div>
                </>
              )}
             {evaluationState?.APU_Evaluation_Mode_1__c !==
                "External exam" &&  <div class="heading_styl">
                <h4>{PGApplicationDetails.Center_Preference}</h4>
              </div>}
              {evaluationState?.APU_Evaluation_Mode_1__c !==
                "External exam" && (
                <div class="form_styl">
                  <div class="inner_part w100">
                    <Notes name="Center_Preference_Help" />
                  </div>
                </div>
              )}
              <div class="form_styl">
                {evaluationState?.APU_Evaluation_Mode_1__c !==
                  "External exam" && (
                  <div class="inner_part">
                    <label>
                      {PGApplicationDetails.Preferred_Test_Center}{" "}
                      <span class="redstyl">* </span>
                    </label>
                    <select
                      {...register("testCenter", {
                        required: {
                          value: true,
                          message: "Please select value",
                        },
                      })}
                      className={`${errors.testCenter ? "error_msg" : ""}`}
                      value={preTestCenter}
                      disabled={
                        applicationData?.hed__Applications_Applicant__r
                          ?.records[0]?.Not_Eligible__c || readOnly &&
                        formattedDate >
                           applicationData?.hed__Applications_Applicant__r
                             ?.records[0]?.Admission_Cycle__r
                             ?.Preference_End_Date__c
                      }
                      onChange={(e) => {
                        setPreTestCenter(e.target.value);
                        dispatch(unsavedchanges(e.target.value));
                        clearErrors("testCenter");
                      }}
                    >
                      <option value="" disabled selected>
                        {AppCommon.Dropdown_Default_Option}
                      </option>
                      {preferencePick &&
                        preferencePick?.testCenter?.map((opt, ind) => (
                          <option key={ind} value={opt.Id}>
                            {opt.value}
                          </option>
                        ))}
                    </select>
                    {errors.testCenter && (
                      <div className="error_shown">
                        {errors.testCenter.message}
                      </div>
                    )}
                  </div>
                )}
                {/* <div class="inner_part">
                  <label>
                    {PGApplicationDetails.Preferred_Interview_Center}{" "}
                    <span class="redstyl">* </span>
                  </label>
                  <select
                    {...register("interviewCenter", {
                      required: {
                        value: true,
                        message: "Please select value",
                      },
                    })}
                    className={`${errors.interviewCenter ? "error_msg" : ""}`}
                    value={preInterviewCenter}
                    onChange={(e) => {
                      setPreInterviewCenter(e.target.value);
                      dispatch(unsavedchanges(e.target.value));
                      clearErrors("interviewCenter");
                    }}
                    disabled={
                      applicationData?.hed__Applications_Applicant__r
                        ?.records[0]?.Not_Eligible__c || readOnly
                      // &&
                      // formattedDate >
                      //   applicationData?.hed__Applications_Applicant__r
                      //     ?.records[0]?.Admission_Cycle__r
                      //     ?.Preference_End_Date__c
                    }
                  >
                    <option value="" disabled selected>
                      {AppCommon.Dropdown_Default_Option}
                    </option>
                    {preferencePick &&
                      preferencePick?.interviewCenter?.map((opt, ind) => (
                        <option key={ind} value={opt.Id}>
                          {opt.value}
                        </option>
                      ))}
                  </select>
                  {errors.interviewCenter && (
                    <div className="error_shown">
                      {errors.interviewCenter?.message}
                    </div>
                  )}
                </div> */}
              </div>

              <div class="form_styl">
                <div class="w100">
                  <button
                    onClick={(e) => (DraftBtn = e.target.value)}
                    value="draft"
                    type="submit"
                    class={
                      applicationData?.hed__Applications_Applicant__r
                        ?.records[0]?.Not_Eligible__c || readOnly
                         &&
                         formattedDate >
                           applicationData?.hed__Applications_Applicant__r
                             ?.records[0]?.Admission_Cycle__r
                             ?.Preference_End_Date__c ?
                          "submit ml_5 disabled"
                        : "submit ml_5"
                    }
                    disabled={
                      applicationData?.hed__Applications_Applicant__r
                        ?.records[0]?.Not_Eligible__c || readOnly
                      &&
                       formattedDate >
                         applicationData?.hed__Applications_Applicant__r
                           ?.records[0]?.Admission_Cycle__r
                           ?.Preference_End_Date__c
                    }
                  >
                    {ApplicationViewPage.Draft_Button_Message}
                  </button>
                  <button
                    onClick={(e) => (DraftBtn = e.target.value)}
                    value=""
                    type="submit"
                    class={
                      applicationData?.hed__Applications_Applicant__r
                        ?.records[0]?.Not_Eligible__c || readOnly &&
                           formattedDate >
                             applicationData?.hed__Applications_Applicant__r
                               ?.records[0]?.Admission_Cycle__r
                               ?.Preference_End_Date__c ?
                          "submit ml_5 disabled"
                        : "submit ml_5"
                    }
                    disabled={
                      applicationData?.hed__Applications_Applicant__r
                        ?.records[0]?.Not_Eligible__c || readOnly
                      &&
                       formattedDate >
                         applicationData?.hed__Applications_Applicant__r
                           ?.records[0]?.Admission_Cycle__r
                           ?.Preference_End_Date__c
                    }
                  >
                    {ApplicationViewPage.Save_And_Proceed_Button_Message}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </Home>
  );
};
export default ApplicationDetailPG;
